import type { storefrontContract, consignmentsContract } from '@montugroup/contracts-warehousing-api';

import type { ClientArgs } from '@ts-rest/core';
import type { InitClientReturn } from '@ts-rest/react-query';
import { createContext } from 'react';

import type { WholesaleApiContextState } from './WholesaleApiContext.types';

export const WholesaleApiContext = createContext<WholesaleApiContextState>({
  accessToken: null,
  bearerToken: '',
  clientApi: function (): InitClientReturn<typeof storefrontContract, ClientArgs> {
    throw new Error('Wholesale clientApi not implemented');
  },
  consignmentClientApi: function (): InitClientReturn<typeof consignmentsContract, ClientArgs> {
    throw new Error('Wholesale clientApi not implemented');
  },
});
